/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller, useFormContext } from "react-hook-form";
import * as MUI from "@mui/material";

type Options = {
  value: string;
  label: string;
};

interface FormInputSelectProps {
  name: string | any;
  label: string;
  items: Options[];
}

export const FormInputSelect: React.FC<FormInputSelectProps> = ({
  name,
  label,
  items,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange, ...field },
        fieldState: { error },
      }) => (
        <MUI.TextField
          {...field}
          select
          helperText={error ? error.message : false}
          error={!!error}
          value={value === undefined ? "" : value}
          label={label}
          onChange={onChange}
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        >
          {items.map((option) => (
            <MUI.MenuItem key={option.value} value={option.value}>
              {option.label}
            </MUI.MenuItem>
          ))}
        </MUI.TextField>
      )}
    />
  );
};
